import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type SparkleIconProps = CreateIconComponentProps;
export const SparkleIcon: React.FC<SparkleIconProps> = ({
  title = 'Sparkle',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M 6 3.447861 C 6 4.574974 6.89545 5.488674 8 5.488674 C 6.89545 5.488674 6 6.402397 6 7.52949 C 6 6.402397 5.10455 5.488674 4 5.488674 C 5.10455 5.488674 6 4.574974 6 3.447861"
    />
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M 12 4.468269 C 12 8.976734 15.5817 12.63153 20 12.63153 C 15.5817 12.63153 12 16.286377 12 20.794796 C 12 16.286377 8.4183 12.63153 4 12.63153 C 8.4183 12.63153 12 8.976734 12 4.468269"
    />
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M 18 17.733572 C 18 18.297142 18.447701 18.753981 19 18.753981 C 18.447701 18.753981 18 19.210815 18 19.774387 C 18 19.210815 17.552299 18.753981 17 18.753981 C 17.552299 18.753981 18 18.297142 18 17.733572"
    />
  </CreateIconComponent>
);
